// Antworttext der KI-Hilfe in Absätze, Zwischenüberschriften und Listen zerlegen (kein HTML aus der Antwort – nur Text,
// **fett**, „# Überschrift“ und Listen).

export type AnswerBlock = { kind: 'p'; text: string } | { kind: 'h'; text: string } | { kind: 'ol' | 'ul'; items: string[] };

const ordered = /^\s*\d+[.)]\s+/;
const bullet = /^\s*[-•*]\s+/;
const heading = /^\s*#{1,4}\s+/;

export function answerBlocks(text: string): AnswerBlock[] {
  const blocks: AnswerBlock[] = [];
  let paragraph: string[] = [];
  const flush = () => {
    if (paragraph.length) blocks.push({ kind: 'p', text: paragraph.join(' ') });
    paragraph = [];
  };
  for (const raw of text.split(/\r?\n/)) {
    const line = raw.trim();
    const kind = ordered.test(line) ? 'ol' : bullet.test(line) ? 'ul' : null;
    if (!line) {
      flush();
    } else if (heading.test(line)) {
      flush();
      blocks.push({ kind: 'h', text: line.replace(heading, '') });
    } else if (kind) {
      flush();
      const item = line.replace(kind === 'ol' ? ordered : bullet, '');
      const last = blocks.at(-1);
      if (last && last.kind === kind) last.items.push(item);
      else blocks.push({ kind, items: [item] });
    } else {
      paragraph.push(line);
    }
  }
  flush();
  return blocks;
}

// inlineParts: **fett** hervorheben, alles andere als Text.
export function inlineParts(text: string): { text: string; strong: boolean }[] {
  return text
    .split(/(\*\*[^*]+\*\*)/)
    .filter(Boolean)
    .map((part) => (part.startsWith('**') && part.endsWith('**') ? { text: part.slice(2, -2), strong: true } : { text: part, strong: false }));
}
